// 应用主配置

export default {
	host:'https://t4.innerchic.cn',
	api:'https://t4.innerchic.cn/im/',
	socketUrl:'wss://t4.innerchic.cn:8090/socket/chatting',
	// 短链接相关
	shortLink:{
		api: 'https://dwz.cn/',
		token: '85a38fb23a824d6cbbbce46682f2f8c3'
	}
}